import { Controller } from "@hotwired/stimulus"
import { MELD_PROVIDER_ICONS, MELD_PROVIDER_SUBTITLES, meldFormatProvider, meldLaunchProvider } from "./meldProviderIcons.js"


export default class extends Controller {
    static targets = ["providerIcon", "feeBreakdown", "feeArrow", "providerOverlay", "providerFrame"]
    static values  = { provider: String, lowKyc: Boolean }

    connect() {
        this._widgetUrl = sessionStorage.getItem("meld_widget_url")
        if (!this._widgetUrl) {
            Turbo.visit("/meld", { action: "replace" })
            return
        }
        this._onCloseOverlay = () => {
            this.providerOverlayTarget.removeAttribute("open")
            this.providerFrameTarget.src = ""
        }
        window.addEventListener("meld:close-overlay", this._onCloseOverlay)
        this._renderProviderIcon()
    }

    disconnect() {
        if (this._onCloseOverlay) window.removeEventListener("meld:close-overlay", this._onCloseOverlay)
    }

    toggleFees() {
        const expanded = this.feeBreakdownTarget.style.display !== "none"
        this.feeBreakdownTarget.style.display = expanded ? "none" : ""
        this.feeArrowTarget.style.transform   = expanded ? "rotate(0deg)" : "rotate(180deg)"
    }

    confirmAndPay() {
        if (!this._widgetUrl) return
        // Keep the user inside the wallet: desktop opens a popup on top of the app, mobile /
        // PWA does a full-page load in the same window. Never an iframe (provider CSP
        // frame-ancestors blocks it and breaks Apple Pay / camera KYC). Completion comes
        // back via the Meld webhook (deposit_confirmed).
        meldLaunchProvider(this._widgetUrl)
    }

    _renderProviderIcon() {
        if (!this.hasProviderIconTarget) return
        const icon = MELD_PROVIDER_ICONS[this.providerValue]
        if (icon) {
            this.providerIconTarget.innerHTML = icon
        } else {
            const badge = document.createElement("span")
            badge.className   = "inline-flex items-center justify-center w-5 h-5 rounded-full text-[10px] font-bold dark:bg-dark-primary-color wdark:bg-wdark-primary-color dark:text-dark-button-text-and-icon wdark:text-wdark-button-text-and-icon"
            badge.textContent = (this.providerValue || "?")[0].toUpperCase()
            this.providerIconTarget.replaceChildren(badge)
        }
    }
}
